import { NonRentableSpaceClass } from '../../../../../../models/space/non-rentable-space.class';
import { AreaUrl } from '../details-overlay.constants';
import { DetailsOverlayData } from '../details-overlay.model';

export const NON_RENTABLE_CONFIG: DetailsOverlayData<NonRentableSpaceClass> = {
  id: space => (space.suiteId || '-').toString(),
  title: space => space.spaceClassificationTitle,
  subsets: [
    {
      label: 'overlayDetails.spaceLocation',
      displayFn: space => space.suiteNumber,
    },
    {
      label: 'commonLabels.spaceSize',
      dataField: 'spaceSize',
      unit: {
        lookupCategory: AreaUrl,
        displayFn: space => space.getAreaSpaceUOM(),
      },
      displayFn: space => space.getAreaSpace(),
      isAreaField: true,
    },
  ],
  notesUpdate: [
    {
      label: 'commonLabels.notes',
      displayFn: space => space.notes,
      class: 'notes',
    },
  ],
  remove: true,
};
